/* Test « archétype animal » — DailyLama
   Maquette : Claude Design « Animal totem.dc.html ».

   Deux couches séparées : un moteur pur, testable sans DOM, puis la couche DOM.
   Aucun hasard, aucun appel réseau pour le calcul, aucune réponse stockée.

   Le thème pose html{font-size:10px} : px uniquement côté CSS.
*/
(function (global) {
  'use strict';

  /* ---------------------------------------------------------------- moteur pur */

  function estEntierPositif(v) { return typeof v === 'number' && isFinite(v) && v > 0; }

  /* Maximum réellement atteignable par archétype : pour chaque question, le meilleur
     poids que cet archétype peut y recevoir. Les maxima diffèrent d'un archétype à
     l'autre, d'où la normalisation — sans elle, l'archétype le plus exposé gagnerait
     structurellement. */
  function maximaParArchetype(questions, ids) {
    var max = {};
    ids.forEach(function (id) { max[id] = 0; });
    questions.forEach(function (q) {
      var meilleur = {};
      q.options.forEach(function (o) {
        Object.keys(o.weights).forEach(function (id) {
          var v = o.weights[id];
          if (!(id in meilleur) || v > meilleur[id]) meilleur[id] = v;
        });
      });
      Object.keys(meilleur).forEach(function (id) {
        if (id in max) max[id] += meilleur[id];
      });
    });
    return max;
  }

  /* Renvoie :
       { kind: 'single', primary, secondary, scores }
       { kind: 'duo', animals: [a, b], scores }
       { kind: 'ambiguous', animals: [...], scores }   plus de deux à égalité au 1er rang
     Lève une erreur si le questionnaire est incomplet : on ne calcule jamais un
     résultat partiel. */
  function computeAnimalResult(questions, answers, profiles) {
    if (!Array.isArray(questions) || !questions.length) throw new Error('questions manquantes');
    if (!Array.isArray(profiles) || !profiles.length) throw new Error('profils manquants');
    if (!answers || typeof answers !== 'object') throw new Error('réponses manquantes');

    var parId = {};
    profiles.forEach(function (p) { parId[p.id] = p; });
    var ids = profiles.map(function (p) { return p.id; });

    var brut = {};
    ids.forEach(function (id) { brut[id] = 0; });

    for (var i = 0; i < questions.length; i++) {
      var q = questions[i];
      var choisi = answers[q.id];
      if (choisi === undefined || choisi === null || choisi === '') {
        throw new Error('questionnaire incomplet : ' + q.id);
      }
      var opt = null;
      for (var j = 0; j < q.options.length; j++) {
        if (q.options[j].id === choisi) { opt = q.options[j]; break; }
      }
      if (!opt) throw new Error('réponse inconnue pour ' + q.id + ' : ' + choisi);
      Object.keys(opt.weights).forEach(function (id) {
        if (id in brut) brut[id] += opt.weights[id];
      });
    }

    var max = maximaParArchetype(questions, ids);
    var scores = ids.map(function (id) {
      var m = max[id];
      return {
        id: id,
        raw: brut[id],
        max: m,
        /* Arrondi à 6 décimales : deux archétypes réellement à égalité doivent le
           rester malgré les flottants, sans pour autant fusionner des écarts réels. */
        score: estEntierPositif(m) ? Math.round((brut[id] / m) * 1e6) / 1e6 : 0
      };
    });

    /* Tri sur le score seul. Aucun départage par ordre alphabétique ni par ordre
       du fichier : une égalité doit rester visible, pas être masquée par le tri. */
    scores.sort(function (a, b) { return b.score - a.score; });

    var tete = scores[0].score;
    var exaequo = scores.filter(function (s) { return s.score === tete; });

    if (exaequo.length > 2) {
      return {
        kind: 'ambiguous',
        animals: exaequo.map(function (s) { return parId[s.id]; }),
        scores: scores
      };
    }
    if (exaequo.length === 2) {
      return {
        kind: 'duo',
        animals: [parId[exaequo[0].id], parId[exaequo[1].id]],
        scores: scores
      };
    }

    /* Complémentaire : uniquement s'il est seul à son rang. Plusieurs seconds à
       égalité ne se départagent pas non plus. */
    var second = scores[1].score;
    var secondsExaequo = scores.filter(function (s) { return s.score === second; });
    return {
      kind: 'single',
      primary: parId[scores[0].id],
      secondary: secondsExaequo.length === 1 ? parId[scores[1].id] : null,
      scores: scores
    };
  }

  function texteDePartage(resultat, url) {
    if (!resultat || !resultat.kind) throw new Error('résultat manquant');
    if (typeof url !== 'string' || url.indexOf('http') !== 0) throw new Error('URL invalide');
    /* Jamais les réponses, jamais les scores, jamais un paramètre d'URL. */
    var quoi;
    if (resultat.kind === 'single') {
      quoi = 'le ' + resultat.primary.label + ' — ' + resultat.primary.archetype.toLowerCase();
    } else if (resultat.kind === 'duo') {
      quoi = resultat.animals[0].label + ' et ' + resultat.animals[1].label + ', à égalité';
    } else {
      quoi = 'plusieurs archétypes à égalité';
    }
    return 'Mon archétype DailyLama du moment : ' + quoi +
           '. Une lecture symbolique à explorer : ' + url;
  }

  global.DailyLamaAnimalTotem = {
    computeAnimalResult: computeAnimalResult,
    maximaParArchetype: maximaParArchetype,
    texteDePartage: texteDePartage
  };
})(typeof window !== 'undefined' ? window : globalThis);

/* ---------------------------------------------------------------- couche DOM */
(function (global) {
  'use strict';
  var API = global.DailyLamaAnimalTotem;
  if (!API) return;

  var doux = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Transport analytics : le point d'entrée canonique du projet est data-api -> /events.
     Les cinq noms de ce test ne figurent pas encore dans l'allowlist du backend :
     l'adaptateur reste donc inerte tant qu'on ne l'a pas branché. Il n'invente aucun
     fournisseur et n'envoie jamais les réponses. */
  var EVENEMENTS = ['animal_quiz_start', 'animal_quiz_complete',
                    'animal_result_article_click', 'animal_result_share', 'animal_quiz_restart'];
  function pister(racine, nom, props) {
    if (EVENEMENTS.indexOf(nom) === -1) return;
    var base = racine.getAttribute('data-api');
    if (!base) return;                       // dégradation silencieuse, jamais d'erreur visible
    if (racine.getAttribute('data-suivi') !== 'actif') return;
    try {
      var charge = { name: nom };
      if (props && props.result_kind) charge.result_kind = String(props.result_kind);
      if (props && props.result_id) charge.result_id = String(props.result_id);
      global.fetch(base.replace(/\/$/, '') + '/events', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(charge), keepalive: true
      }).catch(function () {});
    } catch (e) { /* le suivi ne doit jamais casser le test */ }
  }

  function monter(racine) {
    var $ = function (s) { return racine.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(racine.querySelectorAll(s)); };

    var brut = $('[data-dlat-donnees]');
    var donnees;
    try { donnees = JSON.parse(brut.textContent); } catch (e) { donnees = null; }
    if (!donnees || !donnees.questions || !donnees.profiles) { montrer('erreur'); return; }

    var QUESTIONS = donnees.questions;
    var PROFILS = donnees.profiles;
    var URL_PAGE = racine.getAttribute('data-url') || (global.location ? global.location.origin + global.location.pathname : '');

    /* État en mémoire uniquement. Aucun localStorage, aucun cookie, aucun paramètre d'URL :
       recharger la page ramène à l'introduction, c'est voulu. */
    var etat = { vue: 'intro', i: 0, reponses: {}, resultat: null };

    var vues = { intro: $('[data-dlat-vue="intro"]'), question: $('[data-dlat-vue="question"]'),
                 resultat: $('[data-dlat-vue="resultat"]'), erreur: $('[data-dlat-vue="erreur"]') };
    var annonce = $('[data-dlat-annonce]');

    function montrer(v) {
      Object.keys(vues).forEach(function (k) { if (vues[k]) vues[k].hidden = k !== v; });
      etat.vue = v;
    }

    function dire(t) { if (annonce) annonce.textContent = t; }

    /* ------------------------------------------------------------- question */
    function peindreQuestion() {
      var q = QUESTIONS[etat.i];
      var n = etat.i + 1, total = QUESTIONS.length;

      $('[data-dlat-compteur]').textContent = 'Question ' + n + ' sur ' + total;
      var barre = $('[data-dlat-barre]');
      barre.style.width = Math.round(100 * n / total) + '%';
      var jauge = $('[data-dlat-jauge]');
      jauge.setAttribute('aria-valuenow', String(n));
      jauge.setAttribute('aria-valuetext', 'Question ' + n + ' sur ' + total);

      var restant = $('[data-dlat-restant]');
      if (restant) {
        var reste = total - n;
        restant.textContent = reste === 0 ? 'Dernière question'
          : reste + (reste > 1 ? ' questions restantes' : ' question restante');
      }

      var titre = $('[data-dlat-question]');
      titre.textContent = q.label;

      var liste = $('[data-dlat-reponses]');
      liste.textContent = '';
      var choisi = etat.reponses[q.id];

      q.options.forEach(function (o) {
        var id = 'dlat-' + q.id + '-' + o.id;
        var li = document.createElement('li');

        var label = document.createElement('label');
        label.className = 'dlat__reponse';
        label.setAttribute('for', id);

        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'dlat-' + q.id;   // radios nommées : navigation aux flèches native
        input.id = id;
        input.value = o.id;
        input.className = 'dlat__radio';
        input.checked = choisi === o.id;
        input.addEventListener('change', function () {
          etat.reponses[q.id] = o.id;
          /* Changer une réponse invalide tout résultat déjà calculé. */
          etat.resultat = null;
          peindreEtatBoutons();
          $$('.dlat__reponse').forEach(function (l) {
            l.classList.toggle('dlat__reponse--choisie', l.getAttribute('for') === id);
          });
        });

        var puce = document.createElement('span');
        puce.className = 'dlat__puce';
        puce.setAttribute('aria-hidden', 'true');

        var texte = document.createElement('span');
        texte.className = 'dlat__reponse-texte';
        texte.textContent = o.label;

        label.appendChild(input);
        label.appendChild(puce);
        label.appendChild(texte);
        if (choisi === o.id) label.classList.add('dlat__reponse--choisie');
        li.appendChild(label);
        liste.appendChild(li);
      });

      peindreEtatBoutons();

      /* Focus sur le titre de la nouvelle question : sans cela, le lecteur d'écran
         reste sur le bouton précédent et n'entend pas la question. */
      titre.focus();
    }

    function peindreEtatBoutons() {
      var q = QUESTIONS[etat.i];
      var repondu = !!etat.reponses[q.id];
      var suivant = $('[data-dlat-suivant]');
      suivant.disabled = !repondu;
      suivant.textContent = etat.i === QUESTIONS.length - 1 ? 'Voir mon résultat' : 'Continuer';
      var precedent = $('[data-dlat-precedent]');
      precedent.disabled = etat.i === 0;
      var manque = $('[data-dlat-manque]');
      manque.textContent = repondu ? '' : 'Choisissez une réponse pour continuer.';
    }

    /* ------------------------------------------------------------- résultat */
    function calculer() {
      var r;
      try {
        r = API.computeAnimalResult(QUESTIONS, etat.reponses, PROFILS);
      } catch (e) {
        montrer('erreur');
        return;
      }
      etat.resultat = r;
      peindreResultat(r);
      montrer('resultat');
      pister(racine, 'animal_quiz_complete', {
        result_kind: r.kind,
        result_id: r.kind === 'single' ? r.primary.id : null
      });
      var h = $('[data-dlat-resultat-titre]');
      if (h) h.focus();
    }

    function carte(p, sur) {
      var el = $(sur);
      if (!el) return;
      el.querySelector('[data-c-label]').textContent = p.label;
      el.querySelector('[data-c-angle]').textContent = p.archetype;
      el.querySelector('[data-c-body]').textContent = p.summary;
      var f = el.querySelector('[data-c-forces]');
      f.textContent = '';
      p.strengths.slice(0, 3).forEach(function (s) {
        var li = document.createElement('li');
        li.className = 'dlat__force';
        li.textContent = s;
        f.appendChild(li);
      });
      var w = el.querySelector('[data-c-watch]'); if (w) w.textContent = p.watchout;
      var a = el.querySelector('[data-c-ask]');   if (a) a.textContent = p.reflectionQuestion;
      var lien = el.querySelector('[data-c-lien]');
      if (lien) {
        lien.href = p.articleUrl;
        lien.textContent = 'Explorer le guide du ' + p.label.toLowerCase() + ' →';
        lien.addEventListener('click', function () {
          pister(racine, 'animal_result_article_click', { result_id: p.id });
        });
      }
    }

    function peindreResultat(r) {
      var solo = $('[data-dlat-solo]'), duo = $('[data-dlat-duo]'), amb = $('[data-dlat-ambigu]');
      solo.hidden = r.kind !== 'single';
      duo.hidden = r.kind !== 'duo';
      amb.hidden = r.kind !== 'ambiguous';

      if (r.kind === 'single') {
        carte(r.primary, '[data-dlat-principal]');
        var comp = $('[data-dlat-complementaire]');
        var sans = $('[data-dlat-sans-second]');
        if (r.secondary) {
          comp.hidden = false; sans.hidden = true;
          carte(r.secondary, '[data-dlat-complementaire]');
        } else {
          /* Plusieurs seconds à égalité : on ne choisit pas à la place du lecteur. */
          comp.hidden = true; sans.hidden = false;
        }
        dire('Résultat affiché : ' + r.primary.label + ', ' + r.primary.archetype + '.');
      } else if (r.kind === 'duo') {
        carte(r.animals[0], '[data-dlat-duo-a]');
        carte(r.animals[1], '[data-dlat-duo-b]');
        dire('Résultat en duo : ' + r.animals[0].label + ' et ' + r.animals[1].label + ', à égalité.');
      } else {
        var l = $('[data-dlat-ambigu-liste]');
        l.textContent = '';
        r.animals.forEach(function (p) {
          var li = document.createElement('li');
          li.className = 'dlat__force';
          li.textContent = p.label + ' — ' + p.archetype;
          l.appendChild(li);
        });
        dire('Plusieurs archétypes arrivent à égalité.');
      }
    }

    /* ------------------------------------------------------------- partage */
    function partager() {
      var r = etat.resultat;
      if (!r) return;
      var texte = API.texteDePartage(r, URL_PAGE);
      var confirme = $('[data-dlat-partage-ok]');
      pister(racine, 'animal_result_share', { result_kind: r.kind });

      if (global.navigator && global.navigator.share) {
        global.navigator.share({ text: texte, url: URL_PAGE }).catch(function () {});
        return;
      }
      var fini = function (ok) {
        confirme.textContent = ok ? 'Résultat copié.' : 'Copie impossible : sélectionnez le texte ci-dessous.';
        var repli = $('[data-dlat-partage-repli]');
        if (repli) { repli.hidden = ok; repli.value = texte; }
      };
      if (global.navigator && global.navigator.clipboard && global.navigator.clipboard.writeText) {
        global.navigator.clipboard.writeText(texte).then(function () { fini(true); },
                                                        function () { fini(false); });
      } else {
        fini(false);
      }
    }

    /* ------------------------------------------------------------- écoutes */
    $('[data-dlat-demarrer]').addEventListener('click', function () {
      etat = { vue: 'question', i: 0, reponses: {}, resultat: null };
      montrer('question');
      peindreQuestion();
      pister(racine, 'animal_quiz_start', {});
    });

    $('[data-dlat-suivant]').addEventListener('click', function () {
      if (!etat.reponses[QUESTIONS[etat.i].id]) return;
      if (etat.i === QUESTIONS.length - 1) { calculer(); return; }
      etat.i += 1;
      peindreQuestion();
    });

    $('[data-dlat-precedent]').addEventListener('click', function () {
      if (etat.i === 0) return;
      etat.i -= 1;
      peindreQuestion();   // la réponse déjà donnée est restaurée par peindreQuestion
    });

    $$('[data-dlat-recommencer]').forEach(function (b) {
      b.addEventListener('click', function () {
        etat = { vue: 'question', i: 0, reponses: {}, resultat: null };
        var c = $('[data-dlat-partage-ok]'); if (c) c.textContent = '';
        var repli = $('[data-dlat-partage-repli]'); if (repli) repli.hidden = true;
        montrer('question');
        peindreQuestion();
        pister(racine, 'animal_quiz_restart', {});
      });
    });

    var bp = $('[data-dlat-partager]');
    if (bp) bp.addEventListener('click', partager);

    var br = $('[data-dlat-reessayer]');
    if (br) br.addEventListener('click', function () { montrer('intro'); });

    racine.setAttribute('data-js', 'oui');
    montrer('intro');
    return etat;
  }

  API.monter = monter;

  /* Le moteur doit rester chargeable hors navigateur : c'est ce qui permet de le
     tester sans DOM. Sans cette garde, un simple require() casse. */
  if (typeof document === 'undefined') return;

  /* Paragraphes de tolérance pour accrocher un titre plutôt qu'un paragraphe. */
  var TOLERANCE_TITRE = 2;

  function replacer(racine) {
    var vers = racine.getAttribute('data-dlat-vers');
    if (!vers) return;
    var profondeur = parseInt(racine.getAttribute('data-dlat-profondeur') || '0', 10);
    if (!(profondeur > 0)) return;

    /* C'est l'enveloppe de section qu'il faut déplacer, pas la seule balise <section> :
       sinon on la sortirait de son conteneur et de ses styles. */
    var bloc = racine.closest ? (racine.closest('.shopify-section') || racine) : racine;

    var conteneur = null;
    var pistes = vers.split(',');
    for (var i = 0; i < pistes.length && !conteneur; i++) {
      conteneur = document.querySelector(pistes[i].trim());
    }
    if (!conteneur || conteneur.contains(bloc)) return;

    /* Le corps de l'article n'est pas toujours plat : selon la mise en page, les
       paragraphes sont au premier niveau ou enveloppés dans un div. On cherche donc
       le vrai conteneur de flux — celui qui porte le plus de paragraphes — au lieu
       de supposer une profondeur. Les paragraphes de l'outil lui-même sont écartés,
       sinon la profondeur se décale dès qu'il a été replacé une première fois. */
    var candidats = Array.prototype.slice.call(
      conteneur.querySelectorAll(':scope > p, :scope > div > p, :scope > div > div > p')
    ).filter(function (e) { return !bloc.contains(e); });
    if (!candidats.length) return;

    var comptes = [];
    candidats.forEach(function (e) {
      var trouve = null;
      for (var k = 0; k < comptes.length; k++) if (comptes[k].parent === e.parentNode) trouve = comptes[k];
      if (!trouve) comptes.push({ parent: e.parentNode, n: 1 });
      else trouve.n++;
    });
    comptes.sort(function (a, b) { return b.n - a.n; });
    var flux = comptes[0].parent;

    var enfants = Array.prototype.slice.call(flux.children).filter(function (e) {
      return !bloc.contains(e) && e !== bloc;
    });
    var paras = enfants.filter(function (e) { return e.tagName === 'P'; });
    if (!paras.length) return;

    var vise = Math.max(1, Math.min(paras.length, Math.round(paras.length * profondeur / 100)));

    /* Un ratio brut tombe volontiers au milieu d'un raisonnement. On préfère la
       couture nette : le premier titre situé au niveau visé ou après. À défaut de
       titre, on retombe sur le paragraphe visé. */
    var vus = 0, ancre = null, avant = true;
    for (var j = 0; j < enfants.length; j++) {
      var e = enfants[j];
      if (e.tagName === 'P') vus++;
      /* Le titre n'est un bon point de couture que s'il est proche : quand le suivant
         est à dix paragraphes, s'y accrocher enfonce l'outil bien plus bas que la
         profondeur demandée. Au-delà de la tolérance, on coupe au paragraphe visé. */
      if (vus >= vise && /^H[23]$/.test(e.tagName) && vus <= vise + TOLERANCE_TITRE) {
        ancre = e; avant = true; break;
      }
      if (vus > vise + TOLERANCE_TITRE) break;
    }
    if (!ancre) { ancre = paras[vise - 1]; avant = false; }
    if (!ancre || !ancre.parentNode) return;

    ancre.parentNode.insertBefore(bloc, avant ? ancre : ancre.nextSibling);
  }

  var demarrage = function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-dlat-racine]')).forEach(function (r) {
      replacer(r);
      monter(r);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrage);
  else demarrage();
})(typeof window !== 'undefined' ? window : globalThis);
